import CloseIcon from "@mui/icons-material/Close";
import NearMeIcon from "@mui/icons-material/NearMe";
import { Box, Button, IconButton, Modal, Slider, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { BIGrey } from "../../assets/helpers";
import { getAddress } from "../../request/Fetchcurrentaddress";
import Getcurrentlocation from "../common/Getcurrentlocation";
import SearchMap from "../sites/SearchMap";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import { toast } from "react-toastify";

const LocationMenuModal = (props) => {
  const { open, onClose, onLocationApply, prevSelectedLocation = {} } = props;
  const [isGettingLocation,setIsGettingLocation] = useState(false);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.JobPostings || {};
  const {
    TEXT_LOCATION = English.JobPostings.TEXT_LOCATION,
    TEXT_DISTANCE = English.JobPostings.TEXT_DISTANCE,
    TEXT_KM = English.JobPostings.TEXT_KM,
    BUTTON_APPLY = English.JobPostings.BUTTON_APPLY,
    BUTTON_CLEARALL = English.JobPostings.BUTTON_CLEARALL,
    TEXT_SEARCH_LOCATION = English.JobPostings.TEXT_SEARCH_LOCATION,
    TEXT_PLEASE_SELECT_LOCATION = English.JobPostings.TEXT_PLEASE_SELECT_LOCATION
  } = LanguageData || {};

  const [searchTerm, setSearchTerm] = useState(prevSelectedLocation?.address || "");
  const [locationDetails, setLocationDetails] = useState(prevSelectedLocation);

  const onCurrentLocationClick = async () => {
    try {
      setIsGettingLocation(true)
      console.log("🌍 Checking current location...");
      let getValue = await Getcurrentlocation();

      if (getValue.default) {
        console.log("❌ Location permission denied");
      } else if (getValue?.lat && getValue?.lng) {
        console.log("✅ Got location coordinates");
        let getLatlng = {
          lat: getValue?.lat,
          lng: getValue?.lng
        };
        let addressData = await getAddress(getLatlng);
        const { city = "", province = "", address = "" } = addressData?.objAddress || {};
        let _addressValue = city ? city + (province ? ", " + province : "") : address;
        setLocationDetails((preValue) => ({
          ...preValue,
          address: _addressValue,
          lat: getValue?.lat,
          lng: getValue?.lng
        }));
        setSearchTerm(_addressValue);
      } else {
        console.log("❌ Location failed");
      }
    } catch (error) {
      console.log("❌ Location check error:", error);
    }finally{
      setIsGettingLocation(false)
    }
  };

  const handleSearch = (place) => {
    let lat = Number(place.geometry.location.lat());
    let lng = Number(place.geometry.location.lng());

    let address = "";
    let city = "";
    let province = "";

    if (place?.address_components.length > 0) {
      for (let i = 0; i < place?.address_components.length; i++) {
        let x = place?.address_components[i];
        if (x.types[0] === "street_number") address += x.long_name + " ";
        if (x.types[0] === "route") address += x.long_name + " ";
        if (x.types[0] === "locality" || x.types[0] === "postal_town") city = x.long_name;
        if (x.types[0] === "administrative_area_level_1") province = x.short_name;
      }
    }

    let _addressValue = city ? city + (province ? ", " + province : "") : address;
    setLocationDetails((preValue) => ({
      ...preValue,
      address: _addressValue,
      lat: lat,
      lng: lng
    }));
    setSearchTerm(_addressValue);
  };

  const onApplyClick = () => {
    if (!locationDetails?.lat || !locationDetails?.lng) {
      toast.error(TEXT_PLEASE_SELECT_LOCATION);
      return;
    }
    onLocationApply(locationDetails);
    onClose();
  };

  const onCloseClick = () => {
    onClose();
  };

  const onCLearAll = () => {
    const obj = {
      address: "",
      lat: null,
      lng: null,
      range: 5
    };

    setLocationDetails(obj);
    onLocationApply(obj);
    setSearchTerm("");
    onClose();
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" sx={{ fontSize: 18 }}>
            {TEXT_LOCATION}
          </Typography>
          <Stack flexDirection={"row"}>
            <IconButton onClick={onCloseClick}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>

        <Stack>
          <Typography sx={{ color: BIGrey }}>{TEXT_LOCATION} *</Typography>
          <Stack flexDirection={"row"} alignItems="center" justifyContent={"space-between"} gap={1}>
            <Stack flexGrow={1}>
              <SearchMap
                setSearchTerm={setSearchTerm}
                searchTerm={searchTerm}
                handleSearch={handleSearch}
                placeholder={TEXT_SEARCH_LOCATION}
                from="jobposting"
              />
            </Stack>
            <IconButton loading={isGettingLocation} disabled={isGettingLocation} color="primary" onClick={onCurrentLocationClick}>
              <NearMeIcon />
            </IconButton>
          </Stack>

          <Typography variant="h6" sx={{ mt: 2 }}>
            {TEXT_DISTANCE}
          </Typography>
          <Stack flexDirection={"row"} alignItems="center" justifyContent={"space-between"} gap={4}>
            <Stack flexGrow={1} ml={1}>
              <Slider
                value={locationDetails?.range}
                min={5}
                max={120}
                onChange={(e, value) => {
                  setLocationDetails((preValue) => ({
                    ...preValue,
                    range: value
                  }));
                }}
              />
            </Stack>
            <Typography>
              {locationDetails?.range || 80} {TEXT_KM}
            </Typography>
          </Stack>
          <Stack flexDirection={"row"} justifyContent="flex-end" gap={2} sx={{ mt: 4 }}>
            <Button variant="outlined" color="primary" onClick={onCLearAll}>
              {BUTTON_CLEARALL}
            </Button>
            <Button variant="contained" color="primary" onClick={onApplyClick}>
              {BUTTON_APPLY}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default LocationMenuModal;
